import React from 'react';
import {getRandomArrayElement} from '../../library';
import {getStoryIntervention} from '../../services/interventionSelection';
import {COPY_STRINGS} from '../../constants/translatedCopy';
import {endUserSession} from '../../services/API';
import story_badge from "../../images/EndofAssessmentComp-img-02.svg";

//Status Enums
const statusTypes = {
  IMPROVED: "improved",
  IMPROVED_WPM: "improved_wpm",
  IMPROVED_ACCURACY: "improved_accuracy",
  WORSE_BOTH: "worse_both",
  WORSE_WPM: "worse_wpm",
  WORSE_ACCURACY: "worse_accuracy",
  NO_CHANGE: "no_change",
};
export const studentStatusTypes = {
  STORY: "story",
  TIMED: "timed",
  GENERIC: "generic",
  ASSESSMENT: "assessment",
}

export class StudentStatus extends React.Component {
  constructor (props){
    super(props);
    this.state = {
      displayText: [],
    };
    this.pointsPerStory = 7;

    //Randomized Copy
    this.onFire = COPY_STRINGS.onFire; //Read Fast & Accurate
    this.goodAccuracy = COPY_STRINGS.goodAccuracy; //Read Accurate
    this.workOn = COPY_STRINGS.workOn; //Work Needed
    this.goodSpeed = COPY_STRINGS.goodSpeed; //Read Fast
    this.wrapUp = COPY_STRINGS.wrapUp //Work Needed
  }

  componentDidMount(){

    let wpmDifference = this.props.currentMetrics.wcpm - this.props.historicMetrics.avgWPM;
    let accuracyDifference = this.props.currentMetrics.accuracy - this.props.historicMetrics.avgAccuracy;
    let totalPoints = this.props.historicMetrics.totalPointsAccrued + this.pointsPerStory;

    let statusType = this.getStatusType(wpmDifference, accuracyDifference);

    let displayText = this.getDisplayText(statusType, wpmDifference, accuracyDifference, totalPoints);
    let textToSpeakArray = this.getTextToSpeak(statusType, wpmDifference, accuracyDifference, totalPoints);
    let sequenceToSpeak = {
      textToSpeak: textToSpeakArray,
      passThroughSpeechTags: true,
      onEnd: this.goHome.bind(this),
    }
    this.props.speech.speakSequence(sequenceToSpeak);
    this.setState({
      displayText: this.processDisplayText(displayText),
    });
  }

  goHome(){
    if(this.props.redirect){
      this.props.history.push('/student/home');
    } else {
      window.setTimeout(() => endUserSession(), 3000);
    }
  }

  getStatusType(wpmDifference, accuracyDifference){
    if(wpmDifference > 0 && accuracyDifference > 0){
      return statusTypes.IMPROVED;
    } else if (wpmDifference > 0){
      return statusTypes.IMPROVED_WPM;
    } else if(accuracyDifference > 0){
      return statusTypes.IMPROVED_ACCURACY;
    } else if(wpmDifference < 0 && accuracyDifference < 0){
      return statusTypes.WORSE_BOTH;
    } else if(wpmDifference < 0){
      return statusTypes.WORSE_WPM;
    } else if(accuracyDifference < 0){
      return statusTypes.WORSE_ACCURACY;
    } else {
      return statusTypes.NO_CHANGE;
    }
  }

  // wrap each piece of text in a div for easier styling
  processDisplayText(textArray){
    return textArray.map((phrase, index) => {
      return (<div className="phrase" key={"phrase" + index}>{phrase}</div>);
    });
  }

  // return different display text for each status case. Although this has some duplication
  // (text which will be the same in all cases which has not been abstracted), this is far more readable than the more abstracted way
  // additionally, this will allow the cases to diverge further in the future without pain
  getDisplayText(statusType, wpmDifference, accuracyDifference, totalPoints){
    const ecouragement = COPY_STRINGS.keep_up;
    let frontBookEnd = COPY_STRINGS.status_stats_speech_front(this.props.currentMetrics.wcpm, this.props.currentMetrics.accuracy);

    switch(statusType){
      case statusTypes.IMPROVED:
        return [
          frontBookEnd,
          COPY_STRINGS.stats_compare_improved(wpmDifference, accuracyDifference),
        ];
        break;
      case statusTypes.IMPROVED_WPM:
        return [
          frontBookEnd,
          COPY_STRINGS.stats_compare_improved_wpm(wpmDifference),
        ];
        break;
      case statusTypes.IMPROVED_ACCURACY:
        return [
          frontBookEnd,
          COPY_STRINGS.stats_compare_improved_accuracy(accuracyDifference),
        ];
        break;
      case statusTypes.WORSE_WPM:
        return [
          frontBookEnd
         // ecouragement
        ];
        break;
      case statusTypes.WORSE_ACCURACY:
        return [
          frontBookEnd
         // ecouragement
        ];
        break;
      case statusTypes.WORSE_BOTH:
        return [
          frontBookEnd
          //ecouragement
        ];
        break;
      case statusTypes.NO_CHANGE:
        return [
          frontBookEnd
         // ecouragement
        ];
        break;
      default:
        return [
          frontBookEnd
          //ecouragement
        ];
        break;
    }
  }

  // return different display text for each status case. Although this has some duplication
  // (text which will be the same in all cases which has not been abstracted), this is far more readable than the more abstracted way
  // additionally, this will allow the cases to diverge further in the future without pain
  getTextToSpeak(statusType, wpmDifference, accuracyDifference, totalPoints){
    let textToSpeakArray = [];

    // if we're not showing stats, simplify speech as well
    if(!this.props.showStats){
      switch(this.props.type){
        case studentStatusTypes.TIMED:
          textToSpeakArray.push({textToSpeak: COPY_STRINGS.times_up_speech});
          break;
        case studentStatusTypes.STORY:
          textToSpeakArray.push({textToSpeak: COPY_STRINGS.finished_story_speech});
          break;
        case studentStatusTypes.ASSESSMENT:
          textToSpeakArray.push({textToSpeak: COPY_STRINGS.finished_assessment_speech});
          break;
        default:
          textToSpeakArray.push({textToSpeak: COPY_STRINGS.all_done_speech});
          break;
      }
      return textToSpeakArray;
    }

    let backBookEnd = getRandomArrayElement(this.wrapUp);

    // if there is no historic data, leave out the comparisons
    if(this.props.historicMetrics.avgWPM <= 0 || this.props.historicMetrics.avgAccuracy <= 0){
      textToSpeakArray.push({textToSpeak: COPY_STRINGS.stats_speech_one})
      textToSpeakArray.push({textToSpeak: this.props.currentMetrics.wcpm.toString()})
      textToSpeakArray.push({textToSpeak: COPY_STRINGS.stats_speech_two})
      textToSpeakArray.push({textToSpeak: this.props.currentMetrics.accuracy.toString()})
      textToSpeakArray.push({textToSpeak: COPY_STRINGS.stats_speech_three})
      textToSpeakArray.push({textToSpeak: backBookEnd})
      return textToSpeakArray;
    }

    switch(statusType){
      case statusTypes.IMPROVED:
        textToSpeakArray.push({textToSpeak: COPY_STRINGS.stats_speech_compare_improved_wpm_one})
        textToSpeakArray.push({textToSpeak: wpmDifference.toString()})
        textToSpeakArray.push({textToSpeak: COPY_STRINGS.stats_speech_compare_improved_wpm_two})
        textToSpeakArray.push({textToSpeak: this.props.currentMetrics.accuracy.toString()})
        textToSpeakArray.push({textToSpeak: COPY_STRINGS.stats_speech_compare_improved_wpm_three})
        textToSpeakArray.push({textToSpeak: getRandomArrayElement(this.onFire)})
        break;
      case statusTypes.IMPROVED_WPM:
        textToSpeakArray.push({textToSpeak: COPY_STRINGS.stats_speech_compare_improved_wpm_one})
        textToSpeakArray.push({textToSpeak: wpmDifference.toString()})
        textToSpeakArray.push({textToSpeak: COPY_STRINGS.stats_speech_compare_improved_wpm_two})
        textToSpeakArray.push({textToSpeak: this.props.currentMetrics.accuracy.toString()})
        textToSpeakArray.push({textToSpeak: COPY_STRINGS.stats_speech_compare_improved_wpm_three})
        textToSpeakArray.push({textToSpeak: getRandomArrayElement(this.goodSpeed)})
        break;
      case statusTypes.IMPROVED_ACCURACY:
        textToSpeakArray.push({textToSpeak: COPY_STRINGS.stats_speech_compare_improved_accuracy_one})
        textToSpeakArray.push({textToSpeak: accuracyDifference.toString()})
        textToSpeakArray.push({textToSpeak: COPY_STRINGS.stats_speech_compare_improved_accuracy_two})
        textToSpeakArray.push({textToSpeak: getRandomArrayElement(this.goodAccuracy)})
        textToSpeakArray.push({textToSpeak: COPY_STRINGS.even_better})
        break;
      case statusTypes.WORSE_WPM:
        textToSpeakArray.push({textToSpeak: getRandomArrayElement(this.goodAccuracy)})
        break;
      case statusTypes.WORSE_ACCURACY:
        textToSpeakArray.push({textToSpeak: COPY_STRINGS.work_to_get_better})
        textToSpeakArray.push({textToSpeak: getRandomArrayElement(this.workOn)})
        break;
      case statusTypes.WORSE_BOTH:
        textToSpeakArray.push({textToSpeak: COPY_STRINGS.work_to_get_better})
        textToSpeakArray.push({textToSpeak: getRandomArrayElement(this.workOn)})
        break;
      case statusTypes.NO_CHANGE:
        break;
      default:
        break;
    }

    textToSpeakArray.push({textToSpeak: backBookEnd})

    return textToSpeakArray;

  }

  getAlertText(){
    if(!this.props.showStats){
      switch(this.props.type){
        case studentStatusTypes.TIMED:
          return COPY_STRINGS.times_up;
        case studentStatusTypes.STORY:
          return COPY_STRINGS.finished_story;
        default:
          return COPY_STRINGS.all_done;
      }
    }
  }

  render() {
    let stats = this.props.showStats ? (
      <div className="stats">
        <div className="statContainer left">
          <div className="stat">{this.props.currentMetrics.wcpm}</div>
          <div className="statDescription">{COPY_STRINGS.speed}</div>
        </div>
        <div className="statContainer right">
          <div className="stat">{this.props.currentMetrics.accuracy + "%"}</div>
          <div className="statDescription">{COPY_STRINGS.correct}</div>
        </div>
      </div>
    ) : null;

    return (
      <div className="endOfStoryModal">
        <div className="alert">{this.getAlertText()}</div>
        <div className="praise">{COPY_STRINGS.great_work}</div>
        <div className="badgeContainer">
          <img className="badge" src={story_badge} alt="" />
        </div>
        {stats}
      </div>
    );
  }
}
